<app-navbar>
    <h2>Companie - Adauga companie</h2>
</app-navbar>

<div class="container">
    <app-check-current-user></app-check-current-user>
</div>

<div class="company-edit-profile light-grey-background pb-60">
    <div class="container">
        <form #addCompanyForm="ngForm" (ngSubmit)="addCompanyData(addCompanyForm)" class="custom-form-one">
            <div class="form-section">
                <div class="form-section-title">
                    <h5 class="custom-section-title">Detalii companie</h5>
                </div>
                <div class="form-block">
                    <div class="form-row">
                        <div class="form-group col-md-12">
                            <label for="companyName">Denumire firma</label>
                            <input type="text" ngModel id="companyName" class="form-control" name="companyName" value='' #companyName='ngModel' required>
                            <div class="error-msg" *ngIf="!companyName.valid && companyName.touched || !companyName.valid && addCompanyForm.submitted">Acest
                                camp este obligatoriu!
                            </div>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-md-12">
                            <label>Descriere firma</label>
                            <!--                            <textarea ngModel id="companyDescription" class="form-control" name="companyDescription" #companyDescription='ngModel' required></textarea>-->
                            <angular-editor [(ngModel)]="htmlContent"
                                            name="companyDescription"
                                            id="companyDescription"
                                            [config]="editorConfig"
                                            #companyDescription='ngModel'
                                            required>
                            </angular-editor>
                            <div class="error-msg" *ngIf="(companyDescription.invalid && companyDescription.touched || companyDescription.invalid && addCompanyForm.submitted)">
                                {{'VALIDATION.REQUIRED' | translate}}
                            </div>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-md-12 profilePhotoSection">
                            <label>Logo Companie</label>
                            <input type="file" class="form-control"  (change)="selectFile($event)" />
                        </div>
                        <div *ngIf="message" class="error-msg" role="alert">{{ message }}</div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-md-6">
                            <label for="country">Tara</label>
                            <select (change)="changeCountry($event)" ngModel
                                    class="form-control"
                                    id="country" name="country" #country='ngModel' required>
                                <option value="">{{'DROPDOWN.COUNTRY' | translate}}</option>
                                <option *ngFor="let country of countries">{{country.name}}</option>
                            </select>
                            <div class="error-msg" *ngIf="country.invalid && (country.touched || addCompanyForm.submitted)">
                                {{'VALIDATION.REQUIRED' | translate}}
                            </div>
                        </div>
                        <div class="form-group  col-md-6">
                            <label for="city">Judet</label>
                            <ng-select2
                                    ngModel
                                    [data]="cities"
                                    [options]="singleSelectOp"
                                    name="city"
                                    #city='ngModel'
                                    id="city"
                                    required
                            >
                            </ng-select2>
                            <div class="error-msg" *ngIf="city.invalid && (city.touched || addCompanyForm.submitted)">
                                {{'VALIDATION.REQUIRED' | translate}}
                            </div>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-md-12">
                            <label for="companyAddress">Adresa firma</label>
                            <input type="text" ngModel id="companyAddress" class="form-control" name="companyAddress" value=''>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-md-6">
                            <label for="fiscalCode">Cod fiscal firma</label>
                            <input type="text" ngModel id="fiscalCode" class="form-control" name="fiscalCode" value='' #fiscalCode='ngModel' required>
                            <div class="error-msg" *ngIf="!fiscalCode.valid && fiscalCode.touched || !fiscalCode.valid && addCompanyForm.submitted">Acest
                                camp este obligatoriu!
                            </div>
                        </div>
                        <div class="form-group col-md-6">
                            <label>Platitor de TVA?</label>
                            <label for="vatCode" class="checkbox-container">DA
                                <input type="checkbox" id="vatCode" name="vatCode" value=true ngModel>
                                <span class="checkmark"></span>
                            </label>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4 form-group" *ngIf="Domains">
                            <label>Domeniul</label>
                            <select [(ngModel)]="selectedDomain" (change)="changeDomain($event)" class="form-control" name="activitySector">
                                <option *ngFor="let country of Domains">{{country.name}}</option>
                            </select>
                        </div>
                        <div class="col-md-4 form-group" *ngIf="subdomains">
                            <label>Subdomenii</label>
                            <ng-select2

                                    [(ngModel)]="selectSubdomains"
                                    [data]="subDomainsArray"
                                    [options]="multiSelectOp"
                                    (valueChanged)="changeSubDomain($event)"
                                    name="companyActivitySubSector"
                            >
                            </ng-select2>
                        </div>
                        <div class="col-md-4 form-group" *ngIf="selected && categoriesArray.length > 0">
                            <label>Categorii</label>
                            <ng-select2

                                    [(ngModel)]="selectedCategories"
                                    [data]="categoriesArray"
                                    [options]="multiSelectOp"
                                    name="companyMicroActivitySector"
                            >
                            </ng-select2>
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group col-md-6">
                            <label for="companyType">Tip de companie</label>
                            <select name="companyType" id="companyType" class="form-control" ngModel>
                                <option value=""> -- Selecteaza optiune -- </option>
                                <option value="entrepreneurial">Antreprenoriala</option>
                                <option value="multinational">Multinationala</option>
                                <option value="state">Stat/Publica</option>
                                <option value="mixed">Mixta</option>
                            </select>
                        </div>
                        <div class="form-group col-md-6">
                            <label for="companyEmployeesLevel">Nivel companie (nr. angajati)</label>
                            <select name="companyEmployeesLevel" id="companyEmployeesLevel" class="form-control" ngModel>
                                <option value=""> -- Selecteaza optiune -- </option>
                                <option value="micro">Micro(1-9)</option>
                                <option value="small">Mica(10-49)</option>
                                <option value="medium">Medie(50-249)</option>
                                <option value="big">Mare(peste 250)</option>
                            </select>
                        </div>
                        <div class="form-group col-md-6">
                            <label for="companyRevenue">Nivel companie (cifra de afaceri)</label>
                            <select name="companyRevenue" id="companyRevenue" class="form-control" ngModel>
                                <option value=""> -- Selecteaza optiune -- </option>
                                <option value="micro">Micro(sub 2 milioane euro)</option>
                                <option value="small">Mica(2-10 milioane euro)</option>
                                <option value="medium">Medie(11-49 milioane euro)</option>
                                <option value="big">Mare(peste 50 milioane euro)</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-section pt-10">
                <div class="form-section-title">
                    <h5 class="custom-section-title">Social Media</h5>
                </div>
                <div class="form-block">
                    <div class="form-row" ngModelGroup="companySocialMedia" #companySocialMedia="ngModelGroup">
                        <div class="form-group col-md-6">
                            <label for="companyFacebook">Facebook</label>
                            <input type="url" pattern="https://.*" placeholder="https://exemplu.com" ngModel id="companyFacebook" class="form-control" name="companyFacebook" ngModel>
                        </div>
                        <div class="form-group col-md-6">
                            <label for="companyInstagram">Instagram</label>
                            <input type="url" pattern="https://.*" placeholder="https://exemplu.com" ngModel id="companyInstagram" class="form-control" name="companyInstagram" ngModel>
                        </div>
                        <div class="form-group col-md-6">
                            <label for="companyLinkedIn">LinkedIn</label>
                            <input type="url" pattern="https://.*" placeholder="https://exemplu.com" ngModel id="companyLinkedIn" class="form-control" name="companyLinkedIn" ngModel>
                        </div>
                        <div class="form-group col-md-6">
                            <label for="companyTikTok">Tik Tok</label>
                            <input type="url" pattern="https://.*" placeholder="https://exemplu.com" ngModel id="companyTikTok" class="form-control" name="companyTikTok" ngModel>
                        </div>
                        <div class="form-group col-md-6">
                            <label for="companyWebsite">Website</label>
                            <input type="url" pattern="https://.*" placeholder="https://exemplu.com" ngModel id="companyWebsite" class="form-control" name="companyWebsite" ngModel>
                        </div>
                        <div class="form-group col-md-6">
                            <label for="companyYouTube">Youtube</label>
                            <input type="url" pattern="https://.*" placeholder="https://exemplu.com" ngModel id="companyYouTube" class="form-control" name="companyYouTube" ngModel>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-section pt-10">
                <div class="form-section-title">
                    <h5 class="custom-section-title">Planuri de angajare</h5>
                </div>
                <div class="form-block">
                    <div class="form-row">
                        <div class="form-group col-md-6">
                            <label for="employmentThisYear">Anul in curs</label>
                            <input type="text" ngModel id="employmentThisYear" class="form-control" name="employmentThisYear">
                        </div>
                        <div class="form-group col-md-6">
                            <label for="employmentNextYear">Anul viitor</label>
                            <input type="text" ngModel id="employmentNextYear" class="form-control" name="employmentNextYear">
                        </div>
                        <div class="form-group col-md-6">
                            <label for="employmentEmergencies">Urgente de angajare</label>
                            <input type="text" ngModel id="employmentEmergencies" class="form-control" name="employmentEmergencies">
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-section pt-10">
                <div class="form-section-title">
                    <h5 class="custom-section-title">Reprezentant companie</h5>
                </div>
                <div class="form-block">
                    <div class="form-row">
                        <div class="form-group col-md-6">
                            <label for="administratorLastName">{{'LOGIN.LAST_NAME' | translate}}</label>
                            <input type="text" ngModel id="administratorLastName" class="form-control" name="administratorLastName">
                        </div>
                        <div class="form-group col-md-6">
                            <label for="administratorFirstName">{{'LOGIN.FIRST_NAME' | translate}}</label>
                            <input type="text" ngModel id="administratorFirstName" class="form-control" name="administratorFirstName">
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-md-6">
                            <label for="administratorTelephone">Telefon</label>
                            <input type="text" ngModel id="administratorTelephone" class="form-control" name="administratorTelephone">
                        </div>
                        <div class="form-group col-md-6">
                            <label for="administratorEmail">E-mail</label>
                            <input type="email" ngModel id="administratorEmail" class="form-control" name="administratorEmail">
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-md-6">
                            <label for="administratorFunction">Functie</label>
                            <input type="text" ngModel id="administratorFunction" class="form-control" name="administratorFunction">
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-row justify-content-end">
                <div class="col-md-12">
                    <app-form-message [success]="formResponse"
                                    
                                    *ngIf="formSent && standardError"></app-form-message>
                </div>

                <div class="col-md-12">
                    <app-form-message [success]="formResponse"
                                    [customErrorMessage]="'O companie cu CIF-ul introdus este deja inregistrata'"
                                    [customSuccessMessage]="'Companie create cu succes.'"
                                    *ngIf="formSent && !standardError"></app-form-message>
                </div>

                <button type="submit" class="green-button">Adaugare</button>
            </div>
        </form>
    </div>
</div>
<app-footer></app-footer>
